/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Pipe, PipeTransform } from "@angular/core";
import { formatNumberMaxDecimals } from "../utils/utils";

@Pipe({
	name: "maxDecimals",
	standalone: true
})
export class MaxDecimalsPipe implements PipeTransform {
	public transform(
		value: number | string | null | undefined,
		maximumFractionDigits: number = 3,
		useGrouping: boolean = false
	): string {
		const numericValue = typeof value === "string" ? Number(value) : (value ?? 0);
		return formatNumberMaxDecimals(numericValue, maximumFractionDigits, useGrouping);
	}
}
